import { motion } from "framer-motion";
import {
    Dumbbell,
    Flame,
    TrendingUp,
    Apple,
    HeartHandshake,
    Activity,
    Trophy,
} from "lucide-react";

const servicios = [
    {
        icon: Dumbbell,
        t: "Entrenamiento Personal",
        d: "Sesiones 1-a-1 con planificación a medida, técnica perfecta y supervisión total.",
    },
    {
        icon: Flame,
        t: "Pérdida de Grasa",
        d: "Protocolo combinado de fuerza, cardio inteligente y nutrición para resultados visibles.",
    },
    {
        icon: TrendingUp,
        t: "Ganancia Muscular",
        d: "Hipertrofia con progresión semanal, técnica avanzada y descanso optimizado.",
    },
    {
        icon: Apple,
        t: "Asesoramiento Nutricional",
        d: "Pautas reales, sostenibles y adaptadas a tu vida. Sin dietas imposibles.",
    },
    {
        icon: HeartHandshake,
        t: "Entrenamiento Femenino",
        d: "Programa específico: glúteo, fuerza, ciclo hormonal y postparto.",
    },
    {
        icon: Activity,
        t: "Rehabilitación & Movilidad",
        d: "Recuperación funcional, prevención de lesiones y trabajo postural.",
    },
    {
        icon: Trophy,
        t: "Preparación Física",
        d: "Deportistas, oposiciones, competición. Rendimiento al límite.",
    },
];

export default function Servicios() {
    return (
        <section
            id="servicios"
            data-testid="servicios-section"
            className="relative bg-[#050505] py-24 md:py-32 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
                    <div>
                        <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                            // EL MÉTODO F YOU
                        </span>
                        <h2 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.9] text-brand-text">
                            SIETE PILARES.
                            <br />
                            <span className="orange-text">UN OBJETIVO.</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-brand-muted">
                        Servicios premium diseñados para cubrir cualquier
                        objetivo. Elige tu camino, nosotros marcamos el ritmo.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
                    {servicios.map((s, idx) => {
                        const Icon = s.icon;
                        const span =
                            idx === 0 || idx === 4
                                ? "lg:row-span-2 lg:col-span-1"
                                : "";
                        const featured = idx === 0;
                        return (
                            <motion.div
                                key={s.t}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ delay: idx * 0.08 }}
                                data-testid={`servicio-card-${idx}`}
                                className={`group relative p-7 md:p-8 transition-all duration-300 cursor-default ${
                                    featured
                                        ? "bg-brand-orange text-black"
                                        : "bg-[#0F0F0F] hover:bg-[#161616]"
                                } ${span}`}
                            >
                                <Icon
                                    className={`mb-6 ${
                                        featured
                                            ? "text-black"
                                            : "text-brand-orange group-hover:text-brand-gold transition-colors"
                                    }`}
                                    size={36}
                                    strokeWidth={1.5}
                                />
                                <h3
                                    className={`font-display text-2xl md:text-3xl leading-tight ${
                                        featured ? "text-black" : "text-brand-text"
                                    }`}
                                >
                                    {s.t.toUpperCase()}
                                </h3>
                                <p
                                    className={`mt-3 text-sm leading-relaxed ${
                                        featured
                                            ? "text-black/80"
                                            : "text-brand-muted"
                                    }`}
                                >
                                    {s.d}
                                </p>
                                <div
                                    className={`mt-6 font-display tracking-[0.3em] text-[10px] ${
                                        featured ? "text-black" : "text-brand-gold"
                                    }`}
                                >
                                    0{idx + 1} / 0{servicios.length}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
